import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'zustand';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
 
   <App />

  
    
  </React.StrictMode>
);
reportWebVitals();

// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
//  import App from './App';

// import reportWebVitals from './reportWebVitals';
// import { Provider } from 'zustand';

// ReactDOM.render(
//    <React.StrictMode>
      
//     <App />
//    </React.StrictMode>,
//    document.getElementById('root')
// );

// reportWebVitals();

